const ItemEmptyTile = () => {
  return (
    <div className="item-tile empty-tile pb-4 px-4">
      <span>No Results available.</span>
    </div>
  );
};

export default ItemEmptyTile;
